import { marketingPage } from './eventPolicy';

export function captureNavigation(target: Element, currentUrl: string, capture: (event: string, properties: Record<string, string>) => void) {
  const anchor = target.closest('a[href]');
  if (!anchor || anchor.hasAttribute('download') || anchor.closest('.ph-no-capture, .ph-mask')) return;
  const href = anchor.getAttribute('href');
  if (!href || href.startsWith('#')) return;
  try {
    const current = new URL(currentUrl);
    const destination = new URL(href, current);
    if (destination.origin !== current.origin) return;
    const page = marketingPage(destination.pathname);
    if (!page) return;
    const location = anchor.closest('footer') ? 'footer' : anchor.closest('[data-resource-categories], [data-free-tools-list]') ? 'resources' : anchor.closest('nav') ? 'nav' : 'content';
    capture('navigation_clicked', { location, destination: page.page });
  } catch { /* Invalid links are not analytics data. */ }
}
